export const EXPERIENCE = [
  {
    type: "dev",
    debut: "Mai 2026",
    fin: "Présent",
    poste: "Développeur Full Stack",
    etablissement: "Esprit d'Entreprise (Cabinet EdE)",
    en: { debut: "May 2026", fin: "Present", poste: "Full Stack Developer" },
  },
  {
    type: "formation",
    debut: "Juin 2026",
    fin: "Présent",
    poste: "Formateur SQL & Power BI",
    etablissement: "Insight Consulting & Learning (ICL)",
    en: { debut: "Jun 2026", fin: "Present", poste: "SQL & Power BI Trainer" },
  },
  {
    type: "dev",
    debut: "Jan 2026",
    fin: "Mai 2026",
    poste: "Développeur Full Stack",
    etablissement: "Yeiayel Consulting",
    en: { debut: "Jan 2026", fin: "May 2026", poste: "Full Stack Developer" },
  },
  {
    // Formateur indépendant intervenant via Arkeup Academy, centre de formation.
    // ACEP et Axian University sont les clients de la mission, pas les employeurs.
    type: "formation",
    debut: "Déc 2025",
    fin: "Jan 2026",
    poste: "Formateur Data Analytics & Data Science",
    etablissement: "Arkeup Academy Océan Indien",
    clients: "ACEP Madagascar, Axian University",
    en: {
      debut: "Dec 2025",
      fin: "Jan 2026",
      poste: "Data Analytics & Data Science Trainer",
    },
  },
  {
    type: "formation",
    debut: "Fév 2025",
    fin: "Mai 2025",
    poste: "Chargé de cours Développement Web",
    etablissement: "E-Media Madagascar",
    en: { debut: "Feb 2025", fin: "May 2025", poste: "Web Development Lecturer" },
  },
  {
    type: "formation",
    debut: "Oct 2024",
    fin: "Mai 2025",
    poste: "Chargé de cours Réseaux Informatiques",
    etablissement: "Université AKAMASOA",
    en: { debut: "Oct 2024", fin: "May 2025", poste: "Computer Networks Lecturer" },
  },
  {
    type: "dev",
    debut: "Août 2023",
    fin: "Nov 2023",
    poste: "Stagiaire Développeur Web Fullstack",
    etablissement: "Constellation Group",
    en: { debut: "Aug 2023", fin: "Nov 2023", poste: "Fullstack Web Developer Intern" },
  },
];
